import React from 'react'
import Section from '../Section'
import ExperienceUnit from '../ExperienceUnit'

import coverLogo from '../../assets/images/experience/cover_logo.png'
import crescendoLogo from '../../assets/images/experience/crescendo_logo.jpg'
import scholarTreeLogo from '../../assets/images/experience/scholartree_white_logo.svg'
import razorfishLogo from '../../assets/images/experience/sr_logo.svg'
import hydroOneLogo from '../../assets/images/experience/hydro_one_logo.jpg'
import pernodRicardLogo from '../../assets/images/experience/pernod_ricard_logo.jpg'
import wmgLogo from '../../assets/images/experience/wmg_logo.jpg'

class ExperienceSection extends React.Component {
  render() {
    return (
      <Section title="Experience">
        <div className="row">
          <ExperienceUnit
            logo={coverLogo}
            colour='#FFFFFF'
            title='Cover'
            link='https://cover.com'
            timeperiod='Jan 2020 - Present'
            subtitle='Techinal Lead. Architect Golang microservices running on Kubernetes.'
          />
          <ExperienceUnit
            logo={crescendoLogo}
            colour='#FFFFFF'
            title='Crescendo'
            link='https://crescendowork.com'
            timeperiod='Feb 2019 - Jan 2020'
            subtitle='Lead Developer. Built interactive Slack bot using Typescript, Node, GraphQL, Postgres'
          />
          <ExperienceUnit
            logo={scholarTreeLogo}
            colour='#FFFFFF'
            title='ScholarTree'
            link='https://scholartree.ca'
            timeperiod='Mar 2017 - Feb 2019'
            subtitle='Co-founder. Built entire site using React, Redux, Apollo, Flow, GraphQL, Next.js, Node.js, Express, PostgreSQL'
          />
          <ExperienceUnit
            logo={razorfishLogo}
            colour='#FFFFFF'
            title='SapientRazorfish'
            link='https://www.sapientrazorfish.com'
            timeperiod='Mar 2014 - Feb 2017'
            subtitle={`Developed REST APIs for Walmart.ca with Scala + Play. Also worked on Walmart.ca's native Android app.`}
          />
          <ExperienceUnit
            logo={hydroOneLogo}
            colour='#FFFFFF'
            title='Hydro One'
            link='https://www.hydroone.com/'
            timeperiod='May 2013 - Aug 2013&nbsp;&nbsp;(Co-op)'
            subtitle={`Developed a desktop application to track report completion using C#, WPF, NHibernate and Microsoft SQL server`}
          />
          <ExperienceUnit
            logo={pernodRicardLogo}
            colour='#FFFFFF'
            title='Pernod Ricard'
            link='https://www.pernod-ricard.com'
            timeperiod='Sep 2012 - Apr 2013&nbsp;&nbsp;(Co-op + Part-time)'
            subtitle={`Developed single-page web apps powered by Java and Google Web Toolkit backed by an Oracle database`}
          />
          <ExperienceUnit
            logo={wmgLogo}
            colour='#FFFFFF'
            title='Windsor Mold Group'
            link='http://www.windsormoldgroup.com/'
            timeperiod='May 2011 - Sep 2012&nbsp;&nbsp;(Co-op + Part-time)'
            subtitle={`Developed internal web applications built on PHP, MySQL, JavaScript, jQuery`}
          />
        </div>
      </Section>
    )
  }
}

export default ExperienceSection



// WEBPACK FOOTER //
// ./src/components/ExperienceSection/index.js